import { useMutation, useQuery, type UseMutationResult, type UseQueryResult } from '@tanstack/react-query';

import { fetchCurrentUser, logoutUser, type CurrentUser } from './api';

export const userKeys = {
  me: ['me'] as const,
};

export function useCurrentUserQuery(): UseQueryResult<CurrentUser> {
  return useQuery({
    queryKey: userKeys.me,
    queryFn: ({ signal }) => fetchCurrentUser(signal),
    staleTime: 5 * 60_000,
  });
}

export function useLogoutMutation(): UseMutationResult<void, Error, void> {
  return useMutation({
    mutationFn: logoutUser,
  });
}
